module.exports = __webpack_public_path__ + "img/evoz.cdafc8f6.jpg";